import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICourierActivitiesState } from './courier-activities';

const courierActivitiesStateSelector = createFeatureSelector<ICourierActivitiesState>('courierActivities');

export const selectResponseBolla = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseRetrieveBolla
);

export const selectResponseMagazzinoPickup = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseMagazzinoPickup
);

export const selectResponseBollaPost = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseRetrieveBollaPost
);

export const selectResponseMagazzinoContatori = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseMagazzinoContatori
);

export const selectResponseStampaScontrinoRitiro = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseStampaScontrinoRitiro
);

export const selectResponseAcquisisciBolla = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseAcquisisciBolla
);

export const selectResponseBollaPostNoPalmare = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseBollaPostNoPalmare
);

export const selectResponseMagazzinoPickupDelete = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseDeleteMagazzinoPickup
);

export const selectAnnullaBolla = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseAnnullaBolla
);

export const selectConsegnaSenzaPalmare = createSelector(
  courierActivitiesStateSelector,
  (state: ICourierActivitiesState) => state.responseConsegnaSenzaPalmare
);
